import React from "react";

export default function PaymentIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        d="M0 6.082a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-12Zm3-1.5a1.5 1.5 0 0 0-1.5 1.5v1.5h21v-1.5a1.5 1.5 0 0 0-1.5-1.5H3Zm19.5 6h-21v7.5a1.5 1.5 0 0 0 1.5 1.5h18a1.5 1.5 0 0 0 1.5-1.5v-7.5Z"
      />
      <path
        fill="currentColor"
        d="M3 15.082a1.5 1.5 0 0 1 1.5-1.5H6a1.5 1.5 0 0 1 1.5 1.5v1.5a1.5 1.5 0 0 1-1.5 1.5H4.5a1.5 1.5 0 0 1-1.5-1.5v-1.5Z"
      />
    </svg>
  );
}
